<template>
  <div class="app">
    <div v-if="matchup">
      <b-progress
        :value="quizProgress"
        :max="barMax"
        v-if="quizProgress"
        height="1rem"
        variant="info"
        class="rounded-0"
      ></b-progress>
    </div>
    <slot />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "Matchup-Layout",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      project: (state) => state.api.currentProject,
      quizProgress: (state) => state.api.quizProgress,
      projectSequences: (state) => state.api.projectSequences,
      matchup: (state) => state.api.currentMatchup,
      countRandomMatchups: (state) => state.api.countRandomIdealMatchups,
    }),

    barMax() {
      return this.calcBarMax();
    },
  },

  methods: {
    calcBarMax: function() {
      if (this.project.sequences) {
        if (this.project.custom_order) {
          return this.matchup.sequence.sequence_length;
        } else {
          return this.countRandomMatchups;
        }
      } else {
        return this.project.questions_sequence;
      }
    },
  },
};
</script>
